import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import YourMatch from "@/pages/YourMatch";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/your-match")({
  head: () => seoHead("/your-match"),
  component: () => (
    <AuthGate><YourMatch /></AuthGate>
  ),
});
